/** @format */

import {createColumnHelper} from '@tanstack/react-table';

import {Typography} from '@mui/material';

import {ColumnType, TanStackTableData} from '../types';
import {getValue} from './getValue';

const createColumns = (model: ColumnType[]) => {
  const columnHelper = createColumnHelper<TanStackTableData>();

  return model
    .toSorted((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map(data => {
      if (data.children) {
        return columnHelper.group({
          id: data.id,
          header: () => <Typography>{data.title}</Typography>,
          columns: data.children.map(subData => {
            const {id, size, sortingFn, sortUndefined, title, cell} = subData;
            return columnHelper.accessor(id, {
              id,
              header: () => <Typography>{title}</Typography>,
              cell: cell ?? (info => getValue(info)),
              enableSorting: Boolean(sortingFn),
              sortingFn,
              sortUndefined,
              size,
            });
          }),
        });
      }
      const {id, size, sortingFn, sortUndefined, title, enableHoverExpand, cell} = data;
      return columnHelper.accessor(id, {
        id,
        header: () => <Typography>{title}</Typography>,
        enableSorting: Boolean(sortingFn),
        meta: {
          enableHoverExpand,
        },
        sortingFn,
        sortUndefined,
        cell: cell ?? (info => getValue(info)),
        size,
      });
    });
};

export {createColumns};
